var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-b-15" },
    [
      _vm.rpc.enabled
        ? _c("Field", {
            attrs: {
              label: _vm.$t("PREDICTIVE_ROUTING_LABEL"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("PREDICTIVE_ROUTING_TT")
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "col-sm-5 col-md-3" }, [
                        _c(
                          "div",
                          { staticClass: "r-form display-flex" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: _vm.isPredictiveRoutingConfigRequired
                                  ? "required"
                                  : "",
                                slim: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ classes }) {
                                      return [
                                        _c("SearchableDropdown", {
                                          staticClass:
                                            "m-0 r-form__searchable-dropdown",
                                          class: classes,
                                          attrs: {
                                            config:
                                              _vm.predictiveRoutingOptions,
                                            searchable: true,
                                            clearable: false,
                                            rules: _vm.isPredictiveRoutingConfigRequired
                                              ? "required"
                                              : ""
                                          },
                                          on: { change: _vm.onConfigChange },
                                          model: {
                                            value: _vm.configDropdownValue,
                                            callback: function($$v) {
                                              _vm.configDropdownValue = $$v
                                            },
                                            expression: "configDropdownValue"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                109257607
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "r-form__input-action-button",
                                class: [
                                  _vm.configDropdownValue ? "m-r-12" : "m-r-20"
                                ],
                                attrs: { type: "button" },
                                on: { click: _vm.triggerGetPredictiveRouting }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-refresh",
                                  class: {
                                    "fa-spin": _vm.isLoadingPredictiveRouting
                                  },
                                  attrs: {
                                    title: _vm.$t("PREDICTIVE_ROUTING_REFRESH")
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.configDropdownValue
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "m-r-20 m-t-8",
                                    attrs: {
                                      href: `#/dashboard/predictive-routing/${_vm.configDropdownValue}`,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-external-link",
                                      attrs: {
                                        title: _vm.$t(
                                          "PREDICTIVE_ROUTING_VIEW_SELECTED"
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: { type: "button" },
                                on: { click: _vm.createNew }
                              },
                              [
                                _c("i", { staticClass: "fa fa-plus" }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("NEW")) + "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isPredictiveRoutingConfigRequired
                              ? _c("label", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "REQUIRED",
                                      expression: "'REQUIRED'"
                                    }
                                  ],
                                  staticClass:
                                    "form-group__label-required-manual m-l-15",
                                  class: { invalid: !_vm.rpc.id }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3637135336
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isConfigMigrated
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-offset-3 col-sm-8 col-md-5" },
              [
                _c("i18n", {
                  staticClass:
                    "bs-callout bs-callout-sm bs-callout-warning m-t-5",
                  attrs: { path: "MIGRATED_SETTINGS_MESSAGE", tag: "div" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "link",
                        fn: function() {
                          return [
                            _c("strong", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "/#/dashboard/predictive-routing",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("MIGRATED_SETTINGS_MESSAGE_LINK")
                                    )
                                  )
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2899048478
                  )
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showMissingConfigWarning
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-offset-3 col-sm-8 col-md-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "bs-callout bs-callout-sm bs-callout-warning m-t-5",
                  attrs: {
                    "data-testid": "campaign-rpc-missing-config-warning"
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("PREDICTIVE_ROUTING_NO_CONFIG_MESSAGE")) +
                      "\n      "
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPriorityBump
        ? _c("Field", {
            attrs: {
              label: _vm.$t("PRIORITY_BUMP"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("PRIORITY_BUMP_TT")
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-md-5" },
                        [
                          _c("vue-slider", {
                            staticClass: "vue-slider-v1 flex--grow",
                            attrs: {
                              tooltip: "active",
                              height: 15,
                              data: _vm.bumpData,
                              "data-value": "id",
                              "data-label": "name",
                              marks: _vm.bumpMarks
                            },
                            on: { change: _vm.onPriorityBumpChange },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "dot",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "vue-slider-dot-handle"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-ellipsis-v",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3682467274
                            ),
                            model: {
                              value: _vm.currentPriorityBump,
                              callback: function($$v) {
                                _vm.currentPriorityBump = $$v
                              },
                              expression: "currentPriorityBump"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              248502135
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "ConfirmationModal",
            {
              attrs: {
                title: _vm.$t("PREDICTIVE_ROUTING_CREATE_HEADER"),
                "show-confirm-button": false,
                "show-cancel-button": false,
                "custom-classes": "erpc-settings-form-modal"
              },
              on: {
                close: function($event) {
                  _vm.showModal = false
                }
              }
            },
            [
              _c("ERPCSettingsForm", {
                attrs: {
                  "show-loader":
                    _vm.createPredictiveRoutingConfigStatus.status === "pending"
                },
                on: {
                  submit: _vm.onSubmitCreateNew,
                  cancel: function($event) {
                    _vm.showModal = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }